import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';

import { useUserInfo } from 'src/hooks/useEmployeeId';

import AppWideBanner from './AppWideBanner';

const ImpersonatingUserBanner: FC = () => {
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  if (userInfo?.impersonatingUserInfo) {
    return (
      <AppWideBanner
        backgroundColor="error"
        color="error"
        text={t('hiring-dashboard-nav:nav.banner.impersonating', {
          employeeName: userInfo.employeeName,
          orgName: userInfo.orgName,
        })}
      />
    );
  }
  return null;
};

export default ImpersonatingUserBanner;
